import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

interface CreateInvoiceParams {
  memberId: string
  orderIds: string[]
}

/** Creates a Stripe invoice for the given orders (does not charge it). */
export function useCreateMemberInvoice() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ memberId, orderIds }: CreateInvoiceParams) => {
      const response = await api.post('/members/:memberId/invoice', {
        params: { memberId },
        body: { orderIds },
      })

      if (!response.success) {
        throw new Error(response.error.message)
      }
      return response.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['orders'] })
      if (data.orders) {
        for (const id of new Set(data.orders.map((o) => o.patientId))) {
          queryClient.invalidateQueries({ queryKey: ['patient-orders', id] })
          queryClient.invalidateQueries({ queryKey: ['patient-treatments', id] })
          queryClient.invalidateQueries({ queryKey: ['patient-timeline', id] })
        }
      }
    },
  })
}
